const ALISON_EMAIL_REGEX = /@alisons?\.ai$/i;
const ALISON_ENTRA_TEST_EMAIL_REGEX = /@[a-z0-9-]*alison\.onmicrosoft\.com$/i;

export function isMixpanelExcludedEmail(email: string): boolean {
  return ALISON_EMAIL_REGEX.test(email) || ALISON_ENTRA_TEST_EMAIL_REGEX.test(email);
}
